import axios from 'axios';
import { API_URL } from 'config/app.config';
import { removeUserData } from 'helpers/StorageHelper';
import { t } from 'i18next';
import { loginRoutes } from 'routes/admin/AdminRoutes';
import { store } from 'store';
import { refreshToken } from 'store/auth/actions/AuthAction';
import { setMaintenanceMode, setOfflineStatus } from 'store/auth/slices/SystemStatusSlice';

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-type': 'application/json',
  },
});
/**
 * Catch the unAuthorized Request
 */
instance.interceptors.response.use(
  (response) => {
    // A real response came back, so the network is up.
    store.dispatch(setOfflineStatus(false));
    return response;
  },
  async (error) => {
    if (!error.response) {
      // Request never reached the server - device/network is unreachable.
      store.dispatch(setOfflineStatus(true));
      return {
        status: false,
        hasError: true,
        message: t('something_went_wrong'),
      };
    }
    store.dispatch(setOfflineStatus(false));

    if (error.response.status === 503 && error.response.data?.maintenance) {
      store.dispatch(setMaintenanceMode(true));
      return {
        status: false,
        hasError: true,
        message: error.response.data?.message,
      };
    }

    if (error.response.status === 401) {
      if (error.response.data?.message == 'token_expired') {
        // access token is expired so get from refresh token
        const response = await refreshToken();
        if (response?.status) {
          redirectHome(false);
        }
      } else {
        // Login Session is expired or invalid refresh token
        setTimeout(() => {
          removeUserData();
          redirectHome(true);
        }, 1000);
      }
      return false;
    } else {
      let message = error?.response?.message || t('something_went_wrong');
      if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }
      return {
        status: false,
        hasError: true,
        message: message,
      };
    }
  }
);
function redirectHome(isLoggedout = false) {
  if (isLoggedout) {
    window.location.assign(loginRoutes.login.path);
  } else {
    window.location.reload();
  }
}
export default instance;
